jQuery(document).ready(function() {
    jQuery("#writer-search").keyup(function() {
        jQuery(".organization-name").hide();
        jQuery(".cell.writer").hide();

        if (jQuery(this).val() != "") {
            jQuery(".organization-name").hide();
            jQuery('.cell.writer[class*="'+jQuery(this).val().toLowerCase()+'"]').show();
            jQuery('.cell.writer[name*="'+jQuery(this).val()+'"]').show();
        } else {
            jQuery(".organization-name").show();
            jQuery(".cell.writer").show();
        }
    });
});

